export const ADD_ARTICLE = "ADD_ARTICLE";
export const ADD_VISIT = "ADD_VISIT";
export const ADD_PATIENT = "ADD_PATIENT";
export const ADD_PATIENTEMAILS = "ADD_PATIENTEMAILS";
export const NEWSLETTERS = "NEWSLETTERS";
export const ADD_ADMIN = "ADD_ADMIN";
export const BACKEND_URL = "BACKEND_URL";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
